export const PURCHASE_MODULE_PRELOAD_PERMISSIONS = [
  'purchase-v2:requisition:view',
  'purchase-v2:requisition:create',
  'purchase-v2:requisition:edit',
  'purchase-v2:po:view',
  'purchase-v2:po:create',
  'purchase-v2:po:edit',
  'purchase-v2:po:cancel',
  'purchase-v2:shipment:view',
  'purchase-v2:shipment:create',
  'purchase-v2:gr:view',
  'purchase-v2:gr:create',
  'purchase-v2:trace:view',
  'purchase-v2:invoice:view',
  'purchase-v2:invoice:create',
  'purchase-v2:invoice:match',
  'purchase-v2:set-fulfillment:view',
  'inventory:locations:view',
  'inventory:config',
  'inventory:items:edit',
  'purchase-v2:config:view',
  'purchase-v2:reports:view',
  'purchase-v2:destino_bol:view',
] as const;
